import { createContext } from 'react';

import { FEATURE_FLAG_DEFAULTS } from './feature-flags';

// Unavailable until a real client reports a variationIndex — never invented.
const FEATURE_FLAG_DETAIL_DEFAULTS = Object.freeze(
   Object.fromEntries(
      Object.entries(FEATURE_FLAG_DEFAULTS).map(([key, value]) => [
         key,
         Object.freeze({ value, variationIndex: null }),
      ])
   )
);

const FeatureFlagDetailsContext = createContext(FEATURE_FLAG_DETAIL_DEFAULTS);

export { FEATURE_FLAG_DETAIL_DEFAULTS };
export default FeatureFlagDetailsContext;
